$('.nav-trigger').on('click', function(event) {
  $(this).toggleClass('nav-trigger--active');

  $('.header__actions').slideToggle();
  $('body').toggleClass('nav-visible');

  event.preventDefault();
});
